import { Crown, Sparkles, Building2, User } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';
import {
  getPlanMeta,
  normalizePlanSlug,
  type PlanSlug,
} from '@/lib/subscriptionPlanMeta';

type SubscriptionPlanBadgeProps = {
  plan: string | null | undefined;
  planId?: number | null;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
};

const sizeClasses = {
  sm: 'text-xs px-2.5 py-0.5 gap-1',
  md: 'text-sm px-3 py-1 gap-1.5',
  lg: 'text-base px-4 py-1.5 gap-2',
};

const iconSizes = {
  sm: 'h-3 w-3',
  md: 'h-3.5 w-3.5',
  lg: 'h-4 w-4',
};

function PlanIcon({ slug, className }: { slug: PlanSlug; className: string }) {
  if (slug === 'live') return <Crown className={className} aria-hidden />;
  if (slug === 'porto2life') return <Building2 className={className} aria-hidden />;
  return <User className={className} aria-hidden />;
}

const SubscriptionPlanBadge = ({
  plan,
  planId,
  size = 'md',
  className,
}: SubscriptionPlanBadgeProps) => {
  const slug = normalizePlanSlug(plan, planId);
  const meta = getPlanMeta(plan, planId);

  return (
    <Badge
      className={cn(
        'inline-flex items-center font-semibold rounded-full border',
        sizeClasses[size],
        meta.badgeClassName,
        className,
      )}
    >
      <PlanIcon slug={slug} className={iconSizes[size]} />
      {size === 'lg' ? meta.label : meta.shortLabel}
      {meta.featured && size !== 'sm' && (
        <Sparkles className={cn(iconSizes[size], 'opacity-90')} aria-hidden />
      )}
    </Badge>
  );
};

export default SubscriptionPlanBadge;
